import { defineComponent as _defineComponent } from 'vue'
import BodyPresetGrid from './preset/grid/BodyPresetGrid.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageEffectsPropertiesCreateBody',
  setup(__props) {


return { __sfc: true,BodyPresetGrid }
}

})